import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '1',
  title: 'Atrae',
  description: 'Aplica el posicionamiento de autoridad en tu primer mensaje.'
}, {
  number: '2',
  title: 'Filtra',
  description: 'Usa nuestras preguntas de calificación para separar el oro de la arena.'
}, {
  number: '3',
  title: 'Cierra',
  description: 'Ejecuta la secuencia de 3 mensajes para finiquitar la transacción con elegancia.'
}];
export function HowItWorks() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-cream-50" data-id="element-101">
      <div className="max-w-5xl mx-auto" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-103">
          <h2 className="text-3xl sm:text-4xl font-bold text-navy-900 mb-4" data-id="element-104">
            Cómo funciona
          </h2>
          <div className="w-24 h-1 bg-gold-500 mx-auto rounded-full" data-id="element-105" />
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-106">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-gold-500/30 -z-10" data-id="element-107" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="relative bg-white p-8 rounded-2xl shadow-lg border border-cream-100 text-center flex flex-col items-center" data-id="element-108">
              <div className="w-16 h-16 bg-navy-900 rounded-full flex items-center justify-center text-gold-500 text-2xl font-bold mb-6 shadow-md border-2 border-gold-500/20" data-id="element-109">
                {step.number}
              </div>
              <h3 className="text-2xl font-bold text-navy-900 mb-4 font-serif" data-id="element-110">
                {step.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-111">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}